<template>
    <UiHeroTop 
    :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />  

    <div class="mt-8 mb-8">
    <ContentBlogArticle :article="blogStore.filterArticlesByTag(blog, 'Additional Info')[0]" />
    </div>

</template>
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});


</script>
